import api from './service'
import { trackLoanInsert } from '../../statsig/trackLoanInsert'


export const getLoans = (params) => api(`/auth/getloans`, params)
export const createNewApplication = async (data, source = 'createnewapplication') => {
    const response = await api(`/auth/createnewapplication`, data, 'post')
    trackLoanInsert(response, source)
    return response
}
export const Switch = (data) => api(`/auth/switch`, data,'post')
export const CheckSignInMethod = (data) => api(`/auth/checksigninmethod`, data,'post')
export const checkCustomerInfo = (header) => api(`/data/companycustomization`, {},'get',header)
export const SetUpOrChangePassword = (data) => api(`/auth/setuporchangepassword`, data,'post')
